module.exports = __webpack_public_path__ + "svg_80x80/django.eb4a77.svg";